var _rect, _path, _path2, _rect2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 35,
    fill: "#F44336"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9166 28.6704L31.3275 29.4784L31.3275 29.4784L31.9166 28.6704ZM35.0003 19.177L34.3236 19.9132C34.7062 20.2649 35.2944 20.2649 35.6771 19.9132L35.0003 19.177ZM38.0841 28.6704L38.6732 29.4785L38.6732 29.4785L38.0841 28.6704ZM35.0003 30.1267L35.0003 31.1267L35.0003 31.1267L35.0003 30.1267ZM32.5056 27.8623C31.348 27.0184 30.1039 25.9857 29.1591 24.8905C28.1902 23.7673 27.667 22.7289 27.667 21.858H25.667C25.667 23.4622 26.5821 24.9651 27.6447 26.1969C28.7314 27.4565 30.1121 28.5924 31.3275 29.4784L32.5056 27.8623ZM27.667 21.858C27.667 20.0003 28.5895 18.8888 29.7464 18.4995C30.9387 18.0982 32.6518 18.3765 34.3236 19.9132L35.6771 18.4407C33.599 16.5306 31.1454 15.9184 29.1085 16.6039C27.0362 17.3013 25.667 19.2537 25.667 21.858H27.667ZM38.6732 29.4785C39.8886 28.5925 41.2693 27.4565 42.3559 26.1969C43.4186 24.9651 44.3337 23.4622 44.3337 21.858H42.3337C42.3337 22.7289 41.8105 23.7673 40.8416 24.8905C39.8967 25.9858 38.6526 27.0184 37.495 27.8623L38.6732 29.4785ZM44.3337 21.858C44.3337 19.2537 42.9645 17.3013 40.8921 16.6039C38.8553 15.9184 36.4017 16.5306 34.3236 18.4407L35.6771 19.9132C37.3488 18.3765 39.0619 18.0982 40.2542 18.4995C41.4111 18.8888 42.3337 20.0003 42.3337 21.858H44.3337ZM31.3275 29.4784C32.6007 30.4065 33.5322 31.1267 35.0003 31.1267L35.0003 29.1267C34.2965 29.1267 33.8962 28.8759 32.5056 27.8623L31.3275 29.4784ZM37.495 27.8623C36.1045 28.8759 35.7042 29.1267 35.0003 29.1267L35.0003 31.1267C36.4685 31.1267 37.4 30.4065 38.6732 29.4785L37.495 27.8623Z",
    fill: "url(#paint0_linear_269_698)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.333 47.9807H27.0996C28.7843 47.9807 30.4872 48.1562 32.1269 48.494C35.0273 49.0916 38.0811 49.1639 41.0113 48.6896C42.456 48.4558 43.8764 48.0982 45.1621 47.4776C46.3228 46.9174 47.7446 46.1277 48.6996 45.2432C49.6532 44.36 50.6463 42.9145 51.3512 41.7846C51.9557 40.8157 51.6633 39.627 50.7072 38.9051C49.6452 38.1032 48.0692 38.1034 47.0074 38.9055L43.9954 41.1808C42.8281 42.0626 41.553 42.8743 40.034 43.1166C39.8513 43.1457 39.66 43.1722 39.4603 43.1954M39.4603 43.1954C39.4002 43.2023 39.3393 43.209 39.2777 43.2153M39.4603 43.1954C39.7033 43.1433 39.9446 42.9934 40.1709 42.7959C41.2429 41.8602 41.3107 40.2834 40.3806 39.2386C40.1648 38.9962 39.9122 38.794 39.6314 38.6265C34.9692 35.8458 27.7154 37.9637 23.333 41.0716M39.4603 43.1954C39.3994 43.2084 39.3385 43.2153 39.2777 43.2153M39.2777 43.2153C38.4054 43.3049 37.3849 43.328 36.2526 43.2211",
    stroke: "url(#paint1_linear_269_698)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18.333,
    y: 37.3334,
    width: 5,
    height: 13.3333,
    rx: 1.5,
    stroke: "url(#paint2_linear_269_698)",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_269_698",
    x1: 35.0003,
    y1: 17.3334,
    x2: 35.0003,
    y2: 30.1267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.46
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_269_698",
    x1: 37.4997,
    y1: 37.3334,
    x2: 37.4997,
    y2: 49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.46
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_269_698",
    x1: 20.833,
    y1: 37.3334,
    x2: 20.833,
    y2: 50.6667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.46
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCon2);
export default __webpack_public_path__ + "static/media/con2.68d190b581bf0f7f8a1e55ce0af6df7d.svg";
export { ForwardRef as ReactComponent };